/**
 * Created by Danila Krupnov on 9/29/25
 */

const LinePrices = {
    "a": [1, 2, 4, 6, 8, 14, 26, 50, 94, 178, 340, 640, 1220, 2020, 3998],
    "b": [2, 4, 8, 14, 26, 50, 94],
    "c": [1, 2, 4, 6, 8, 14, 26, 50, 94, 178, 340, 640, 1220, 2020],
    "d": [3, 6, 12, 22, 42, 82, 162],
    "e": [13, 24, 46, 86, 166, 320, 600, 1120, 2140, 4080],
    "f": [6, 11, 20, 36, 68, 130, 260],
    "g": [1, 2, 4, 8, 14, 28, 52, 100, 188, 360, 720],
    "h": [8, 16, 30, 58, 110, 200, 380],
    "i": [3, 6, 12, 22, 42, 78, 148, 280, 540, 1040, 2000, 3800],
    "o": [4, 8, 14, 25, 49, 96, 184, 354, 679, 1305],
    "p": [4, 8, 14, 25, 49, 96, 184, 354, 679, 1305],
    "q": [4, 8, 14, 25, 49, 96, 184, 354, 679, 1305],
    "r": [4, 8, 14, 25, 49, 96, 184, 354, 679, 1305],
    "s": [4, 8, 14, 25, 49, 96, 184, 354, 679, 1305],
    "t": [4, 8, 14, 25, 49, 96, 184, 354, 679, 1305],
    "u": [4, 8, 14, 25, 49, 96, 184, 354, 679, 1305],
    "ff": [null, null, null, null, 20, 50],
    "AB": [80],
    "CD": [80],
    "E": [90],
    "F": [90],
    "GH": [90],
    "I": [90],

    "lr": [199],
    "pc": [99],
    "sc": [99],
    "am": [5, 10, 20],
    "ec": [10, 20, 40],
    "hg": [20, 40, 80]
};